import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

export const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="grid min-h-screen bg-[#0B0F17] lg:grid-cols-2">
    <div className="flex flex-col px-6 py-8 sm:px-12">
      <Logo />
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-12">
        <h1 className="font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-3 text-slate-400">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-8 text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
    <div className="relative hidden overflow-hidden lg:block grain">
      <img src="/img/action.jpg" alt="Team on the pitch" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/30 to-transparent" />
      <div className="absolute bottom-12 left-12 right-12">
        <p className="font-display text-5xl font-black uppercase leading-none text-white">Every club. <span className="text-[#CCFF00]">One pulse.</span></p>
        <Link to="/t/riverside-rovers" className="mt-4 inline-block text-sm text-slate-300 underline-offset-4 hover:underline">Peek at a demo hub →</Link>
      </div>
    </div>
  </div>
);
